
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppButton } from '@/components';
import { useGameVariantAdd } from '@/modules/game/variant/model/add';
import { ROUTE_NAME_GAME } from '@/modules/game/router';

export default defineComponent({
    name: ROUTE_NAME_GAME.VARIANT.ADD,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppButton },
    setup() {
        const { model, v$, create } = useGameVariantAdd();

        return { model, v$, create };
    }
});
